import { render } from "./risk_review.html?vue&type=template&id=2a2586b8&scoped=true&external"
import script from "./risk_review.js?vue&type=script&lang=js&external"
export * from "./risk_review.js?vue&type=script&lang=js&external"

import "./risk_review.css?vue&type=style&index=0&id=2a2586b8&scoped=true&lang=css&external"
import "../Verification/manage_verification.css?vue&type=style&index=1&id=2a2586b8&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2586b8"]])

export default __exports__